import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import useApi from "../../api";
import ApplicableProductTable from "./applicableProductTable";
import AddProductPromo from "./addProductPromo";
import { StatusBar } from "../common";

const redemptionCountStatus = [
  { value: "0", label: "0+" },
  { value: "10", label: "10+" },
  { value: "50", label: "50+" },
  { value: "100", label: "100+" },
  { value: "500", label: "500+" },
  { value: "1000", label: "1000+" },
]


function ApplicableProducts({ isOpen, onClose, code }: {isOpen: boolean; onClose: () => void; code: string | null}) {
  const [products, setProducts] = useState<any>({});
  const [addPromoProductModal, setAddPromoProductModal] = useState(false);
  const api = useApi();

  const fetchAttachedProducts = () => {
    const params = {
        promo_code: code
    }
    api.getProductsWithPromo(params).then((response) => {
        setProducts(response)
    }, (error) => {
        toast.error("Failed to fetch promocode details")
    })
  }

  useEffect(() => {
    fetchAttachedProducts();    
  }, [code]);

  return (
    <NxtbnDrawer title={`Applicable product of ${code}`} isOpen={isOpen} onClose={onClose}>
      <StatusBar
        onButtonClick={()=>setAddPromoProductModal(!addPromoProductModal)}
        statusList={redemptionCountStatus} 
        currentStatus={''} 
        onChangeStatus={() => {}} 
        buttonLabel="Attach Product"
      />
       <ApplicableProductTable products={products.results || []} />


      <AddProductPromo onRefresh={fetchAttachedProducts} isOpen={addPromoProductModal} onClose={() => setAddPromoProductModal(false)} code={code} />
    </NxtbnDrawer>
  );
}

export default ApplicableProducts;
